// extracted by mini-css-extract-plugin
export default {"root":"EntityList_root__K5X9S","container":"EntityList_container__XpLuJ"};